import React, { useState, useReducer, useMemo, useEffect } from 'react';
import { useIntl, history } from 'umi';
import { Segment } from 'tea-component';
import StatsComp from './index';
import classnames from 'classnames';
import './index.scss';
import { IAction, IFilterProps, TDimension, TEntityType } from './type';

const reducer = (state: IFilterProps, { type, payload }: IAction) => ({
  ...state,
  [type]: payload,
});

const INCOMING_PARAMS_MAP: Record<any, TDimension> = {
  game: 'games',
};

export default function Comp(props: any) {
  const {
    // genreSource,
    entityType,
    activeId,
    pageId,
    changeLeftSegment,
    marketName,
    marketNameEn,
    defaultDimension,
    defaultDateRange,
    defaultDateType,
  } = props;
  const dateRange = defaultDateRange ? defaultDateRange?.split(',') : ['', ''];
  const [leftSegment, setLeftSegment] = useState<TEntityType>(entityType);
  const [rightSegment, setRightSegment] = useState(
    INCOMING_PARAMS_MAP[defaultDimension] || 'operation',
  );
  const [destroyed, setDestroyed] = useState(false);
  const [gameTypeDisable, setGameTypeDisable] = useState(false);
  // const [countryId, setCountryId] = useState('');

  const { formatMessage } = useIntl();
  const countryList = ['us', 'de', 'gb', 'fr', 'es'];

  const isAnnie: any = useMemo(() => history.location.query?.isAnnie, [history.location]);

  const handleDestroyed = () => {
    setDestroyed(true);
    setTimeout(() => {
      setDestroyed(false);
    }, 0);
  };

  const [filter, filterDispatch] = useReducer(reducer, {
    marketType: leftSegment,
    dimension: rightSegment,
    startDate: dateRange?.[0] || '',
    endDate: dateRange?.[1] || '',
    granularity: defaultDateType || 'monthly',
    dataSource: 'sensortower',
    singleGenre: [],
    genres: ['All'],
    regions: [],
  });
  // console.log(filter);

  useEffect(() => {
    const marketNameEnCur = marketNameEn || history.location.query?.marketNameEn;
    // setCountryId(marketNameEnCur);

    // PC console选项是否可用，只有 countryList 中的国家才可用
    const countryHasPcConsoleData = countryList.indexOf(marketNameEnCur) == -1;
    setGameTypeDisable(countryHasPcConsoleData);
  }, []);

  return (
    <div className="dbi-genre-tabdetails--stats">
      <div className="dbi-genre-segment">
        <Segment
          className="segment-light dbi-segment-right"
          value={leftSegment}
          onChange={(value: TEntityType) => {
            // console.log('left segment change', value);
            if (changeLeftSegment) {
              changeLeftSegment(value);
            }
            filterDispatch({ type: 'marketType', payload: value });
            handleDestroyed();
            setLeftSegment(value);

            history.replace(
              `/intelligence/marketProfile/${activeId}/detail?marketName=${marketName}&marketNameEn=${marketNameEn}&pageId=${pageId}&segment=${value}${
                isAnnie ? `&isAnnie=${isAnnie}` : ''
              }`,
            );
          }}
          options={[
            {
              text: formatMessage({ id: 'dbi_market_mobile' }),
              value: 'mobile',
            },
            {
              text: formatMessage({ id: 'dbi_market_pc' }),
              value: 'pc',
              // className: pcGameSegmentClassName,
              disabled: gameTypeDisable,
            },
            {
              text: formatMessage({ id: 'dbi_market_console' }),
              value: 'console',
              disabled: gameTypeDisable,
            },
          ]}
        />
        <Segment
          className={classnames('segment-light')}
          value={rightSegment}
          onChange={(value: TDimension) => {
            filterDispatch({ type: 'dimension', payload: value });
            handleDestroyed();
            setRightSegment(value);
          }}
          options={[
            {
              text: formatMessage({ id: 'dbi_market_operation_data' }),
              value: 'operation',
            },
            {
              text: formatMessage({ id: 'dbi_market_by_game' }),
              value: 'games',
            },
            {
              text: formatMessage({ id: 'dbi_market_by_genres' }),
              value: 'genres',
            },
            {
              text: formatMessage({ id: 'dbi_market_by_companies' }),
              value: 'companies',
            },
          ]}
        />
      </div>
      {destroyed ? null : (
        <StatsComp
          {...props}
          leftSegment={leftSegment}
          rightSegment={rightSegment}
          destroyed={destroyed}
          filter={filter}
          filterDispatch={filterDispatch}
        />
      )}
    </div>
  );
}
